export default __webpack_public_path__ + "static/media/ic-phone.4889b885.svg";